import React from 'react'
import { NavLink } from "react-router-dom"
 
import HeaderUser from './HeaderUser'
import { useState } from 'react';



const HeaderMenu = (props) => {


    const [showMenu, setShowMenu] = useState(false);

    const onToggleMenu = () => {
        setShowMenu(!showMenu)
    }
    const navegarGlosario = () => {
        window.location.href = 'glosario';
    }
    const scrollToElement = (element) => {
        setShowMenu(false);
        setTimeout( 
            function(){
            const el = document.getElementById(element)
            const y = el.getBoundingClientRect().top + window.pageYOffset - 65

            window.scrollTo({ top: y, behavior: 'smooth' })
                }
            ,100
        )
    }

    return (
        <>
        <div className="home__itemsMenu d-none d-md-flex">
            {
                (!props.globalAutenticado)
                ? <>
                    <NavLink to={'/'} onClick={() => scrollToElement('coberturas')}>
                        TUS COBERTURAS
                    </NavLink>

                    {/*<div onClick={() => document.getElementById('seguro').scrollIntoView()}>*/}
                    <NavLink to={'/'} onClick={() => scrollToElement('siniestro')}>
                        REPORTA UN SINIESTRO
                    </NavLink>
                    <NavLink to={'/'} onClick={() => scrollToElement('faq')}>
                        PREGUNTAS FRECUENTES
                    </NavLink>
                    <NavLink to={'/glosario'}>
                        GLOSARIO
                    </NavLink>
                </>
                : <HeaderUser />
            }
        </div>
        <div className="menu__hambur d-flex d-md-none" onClick={onToggleMenu}>
            <div></div>
            <div></div>
            <div></div>
        </div>

        <div className={`menu__movil d-block d-md-none ${showMenu ? 'menu__movil__show' : ''}`}>
            <div className="menu__movil__overlay">
                <div className="menu__movil__content">
                    <div className="menu__movil__hambur" onClick={onToggleMenu}>
                        Cerrar X   
                    </div>
                    <div className="menu__movil__text">
                    <p><NavLink to={'/'} onClick={() => scrollToElement('coberturas')}>
                        Coberturas
                    </NavLink></p>
                    <p><NavLink to={'/'} onClick={() => scrollToElement('siniestro')}>
                        Siniestro
                    </NavLink></p>
                    <p><NavLink to={'/'} onClick={() => scrollToElement('faq')}>
                        FAQs
                    </NavLink></p>
                    <p><NavLink onClick={() => navegarGlosario()}>
                        Glosario
                    </NavLink></p>
                    <p><NavLink to={'/'} onClick={() => scrollToElement('contacto')}>
                        Contacto
                    </NavLink></p>
 
                    </div>

                </div>
            </div>
        </div>

        </>
    )
}

export default HeaderMenu